import React from 'react';
import './App.css';
import MainLayout from 'components/layouts/MainLayout';
import '@progress/kendo-theme-default/dist/all.css';
import version from '../package.json';

export const GlobalStateContext = React.createContext();

export default function App() {
  return (
    <div className="App" height="100%" width="100%">
      <MainLayout version={version.version} />
    </div>
  );
}
